module.exports = __webpack_public_path__ + "img/Azure.660faf36.svg";